import { WizardContainerComponentProps } from '../wizard-container.model';
import { ViewScreenController } from './view-screen.controller';

const ViewScreen = (props: WizardContainerComponentProps): JSX.Element => {
  return <ViewScreenController {...props} />;
};
export default ViewScreen;
